'use strict';

var GenericWorker = require("./stream/GenericWorker");

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function (compressionOptions) {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = require('./flate');



/*****************
 ** WEBPACK FOOTER
 ** ./~/jszip/lib/compressions.js
 ** module id = 256
 ** module chunks = 0
 **/